<!-- 仓库主数据 -->
<template>
  <div class="store">
    <sirui-search
      ref="storeDataSearch"
      :query="query"
      :columns="searchFormColumns"
      :defaultRow="2"
      @changeCompanyHandler="changeCompanyHandler"
      @changeDepartmentHandler="changeDepartmentHandler"
      @changeSupplyChainMethod="changeSupplyChainMethod"
      @resetBtnClick="resetBtnClickHandler"
      @searchBtnClick="queryBtnClickHandler"
    ></sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :showFooter="true"
        :footerMethod="footerMethod"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :pageSizes="pageSizes"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <!-- 0512 客户名称常驻原因，去掉序号显示 -->
        <!-- <vxe-table-column
          type="seq"
          width="50"
          title="序号"
          v-if="columnList.length"
        ></vxe-table-column> -->
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'expenseType'">{{
              expenseType?.find((item) => item.value == row['expenseType'])?.label
            }}</template>
            <!-- <template v-else-if="item.field === 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
              }}</template> -->
            <template v-else-if="item.field === 'processStatus'">{{
              row.processStatus == '0' ? '未处理' : '已处理'
            }}</template>
            <template v-else-if="item.field === 'createMethod'">{{
              row.createMethod == '01' ? '系统' : '手动'
            }}</template>
            <template v-else-if="item.field === 'businessCategory'">{{
              businessCategory?.find((item) => item.value == row['businessCategory'])?.label
            }}</template>
            <template v-else-if="item.field === 'originalAmount'">{{
              row['originalAmount'].toFixed(2)
            }}</template>
            <template v-else-if="item.field === 'domesticAmount'">{{
              row['domesticAmount'].toFixed(2)
            }}</template>
            <template v-else-if="item.field === 'originalPrice'">{{
              row['originalPrice'].toFixed(3)
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- <GenerateExpensesDialog :showDialog="showGenerateExpensesDialog" :form="generateExpensesDialogform"
      @closeDialog="showGenerateExpensesDialog = false" @save="saveGenerate">
    </GenerateExpensesDialog> -->
    <!-- <CreateCostDialog
      :showDialog="showGenerateExpensesDialog"
      :form="generateExpensesDialogform"
      @closeDialog="showGenerateExpensesDialog = false"
      @save="saveGenerate"
    > -->
    <ListContractDialog
      :showDialog="showContractDialog"
      @closeDialog="showContractDialog = false"
      @saveCost="saveCost"
    >
    </ListContractDialog>
    <addExpensesDialog
      ref="AddExpensesDialogRef"
      :showDialog="showAddExpensesDialog"
      :form="addExpensesDialogForm"
      :selectedList="selectedList"
      @closeDialog="showAddExpensesDialog = false"
      @save="saveGenerate"
    >
    </addExpensesDialog>
    <adjustmentFeeDialog
      ref="AddExpensesDialogRef"
      :showDialog="showAdjustmentFeeDialog"
      :form="addExpensesDialogForm"
      :selectedList="selectedList"
      @closeDialog="showAdjustmentFeeDialog = false"
      @save="saveGenerate"
    >
    </adjustmentFeeDialog>
    <batchCreateSettlementDialog
      ref="AddExpensesDialogRef"
      :showDialog="showBatchCreateSettlementDialog"
      :form="addExpensesDialogForm"
      :selectedList="selectedList"
      :tableData="preSettlementTableData"
      @closeDialog="showBatchCreateSettlementDialog = false"
      @save="savePreGenerate"
    >
    </batchCreateSettlementDialog>
  </div>
</template>

<script>
  import { searchColumns, defaultTableColumn, defaultMenuBtnList } from './index.js';
  // import GenerateExpensesDialog from './components/generateExpensesDialog.vue';
  // import CreateCostDialog from './components/creatCostDialog.vue';
  import ListContractDialog from './components/listContractDialog.vue';
  import addExpensesDialog from './components/addExpensesDialog.vue';
  import adjustmentFeeDialog from './components/adjustmentFee.vue';
  import batchCreateSettlementDialog from './components/batchCreateSettlementDialog.vue';
  import RECEIVABLES_PROPERTY from '@/api/receivablesAndPayables/trade.js';
  import parkPropertyApi from '@/api/receivablesAndPayables/parkProperty.js';
  import expenseListMixin from './index.js';
  export default {
    mixins: [expenseListMixin],
    props: {
      contractNo: {
        type: String,
        default: () => '',
      },
    },
    name: 'ParkProperty',
    components: {
      // GenerateExpensesDialog,
      // CreateCostDialog,
      ListContractDialog,
      addExpensesDialog,
      adjustmentFeeDialog,
      batchCreateSettlementDialog,
    },
    computed: {
      searchFormColumns() {
        return searchColumns(this);
      },
      expenseType() {
        return this.$baseRequest.getDictListMapByType('property_settlement_cost');
      },
      // basic_unit() {
      //   return this.dictListMap.basic_unit;
      // },
      businessCategory() {
        return this.dictListMap?.businessCategory;
      },
    },
    mounted() {
      // this.getTableData();
      this.getButtonList();
      // this.query.contractNo = this.contractNo;
      console.log('this.$parent.contractNo', this.$parent.contractNo, this.$parent);
      // console.log(JSON.parse(localStorage.getItem('userInfo')).userInfo.oaId, '费用清单');
    },
    data() {
      return {
        loading: false,
        handleRejectValue: '',
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        selectedList: [],
        tableData: [], // 表格数据
        importUrl: '',
        importData: {},
        columnList: [],
        // showGenerateExpensesDialog: false,
        showAddExpensesDialog: false,
        showContractDialog: false,
        showAdjustmentFeeDialog: false,
        showBatchCreateSettlementDialog: false,
        generateExpensesDialogform: {},
        addExpensesDialogForm: {},
        preSettlementTableData: [],
        query: {
          pageNum: 1,
          pageSize: 10,
          businessCompanyNo: '', //公司名称
          businessDepartmentCode: '', //公司名称
          processStatus: null, //状态
          expenseTypeList: '', //费用类型
          businessCategory: '04', //业务类别
          accountPeriod: '', //应收账期
          periodDateStart: '', //业务账期从
          periodDateEnd: '', //业务账期至
          customerNo: '', //客户名称
          spaceAssetNameLike: '', //空间资产
          contractNo: '', //合同编号
          createMethod: '', //创建方式
          settlementNoLike: '', //结算单编号
          originalAmountStart: '', //原币结算金额(含税)
          originalAmountEnd: '', //原币结算金额(含税)
          expenseGenerationDateStart: '', //费用生成日期从
          expenseGenerationDateEnd: '', //费用生成日期至
          salesmanNo: '', //业务员
        },
        companyCode: null,
        tableTotal: 15,
        pageSizes: [10, 20, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 2000, 3000],
      };
    },
    methods: {
      footerMethod({ columns }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (columnIndex === 3) {
              return `原币结算金额（含税） `;
            } else if (columnIndex === 5) {
              return `本币结算金额（含税）`;
            }
            return null;
          }),
        ];
      },
      //获取菜单按钮
      getButtonList() {
        this.menuButtonList = defaultMenuBtnList;
        console.log('defaultMenuBtnList', defaultMenuBtnList);
        this.getColumnInfo();
      },
      // 计算选中金额
      _computedAmount(selection) {
        console.log(selection);
        const originalAmount = selection.reduce(
          (prev, cur) =>
            prev + this.$utils.toNumber(this.$utils.toNumber(cur.originalAmount).toFixed(2)),
          0
        );
        const domesticAmount = selection.reduce(
          (prev, cur) =>
            prev + this.$utils.toNumber(this.$utils.toNumber(cur.domesticAmount).toFixed(2)),
          0
        );
        const allTdDom = document.querySelector('.vxe-footer--row').querySelectorAll('td');
        const totalDom1 = allTdDom[4];
        const totalDom2 = allTdDom[6];
        totalDom1.querySelector('.vxe-cell').innerHTML = this.$utils.commafy(
          this.$utils.toNumber(originalAmount).toFixed(2),
          this.$globalVar.qPoint
        );
        totalDom2.querySelector('.vxe-cell').innerHTML = this.$utils.commafy(
          this.$utils.toNumber(domesticAmount).toFixed(2),
          this.$globalVar.qPoint
        );
      },
      // 切换供应商
      changeSupplyChainMethod(val) {
        console.log(val, '修改客户');
        const rowData = val[0];
        this.query = {
          ...this.query,
          customerNo: rowData?.partnerCode,
        };
      },
      // 修改合同
      changeContractMethod(val) {
        this.query.contractNo = val[0].contractNo;
        console.log(val, '修改合同');
      },
      // 修改业务员
      changeSalesmanNoMethod(val) {
        this.query.salesmanNo = val[0]?.personNo || '';
      },

      //获取当前列
      getColumnInfo() {
        this.getColumnList(defaultTableColumn).then(() => {
          this.columnList = defaultTableColumn;
        });
      },
      // 获取表格数据
      async getTableData(search) {
        console.log(search, '搜索');
        this.loading = true;
        const postData = {
          ...this.query,
          processStatus: this.query.processStatus == null ? null : +this.query.processStatus,
          pageNum: this.$refs.siruiTable?.page.pageNum,
          pageSize: this.$refs.siruiTable?.page.pageSize,
          businessGroup: this.userInfo.businessGroup,
        };
        const { data } = await this.$axios.post(
          RECEIVABLES_PROPERTY.RECEIVABLESEXPENSE_QUERY,
          postData
        );
        console.log(data, '应收费用清单');
        this.loading = false;
        this.tableData = data.data.records;
        this.$refs.siruiTable.setPageTotal(data.data.total);
      },
      // 表格上面的按钮
      chooseClick(type) {
        this[type]();
      },
      delete() {
        console.log('删除', this.multipleSelection);
        let selectedList = this.$refs.siruiTable.getCheckboxRecords();
        if (!selectedList.length) {
          this.$message.warning('请选择行操作');
          return;
        }
        // console.log(
        //   selectedList[0].processStatus,
        //   selectedList[0].createMethod,
        //   [1].includes(selectedList[0].processStatus),
        //   ['01'].includes(selectedList[0].createMethod)
        // );
        // processStatus 状态
        // let processStatusList = selectedList.filter(
        //   (item) => [1].includes(item.processStatus) || ['01'].includes(item.createMethod)
        // );
        // if (processStatusList.length != selectedList.length) {
        //   this.$message.warning('所选择的数据包含不可删除的数据，请确认');
        //   return;
        // }
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const postData = [];
            selectedList.map((item) => {
              postData.push(+item.id);
            });
            const { data } = await this.$axios.post(parkPropertyApi.RECEIVABLESEXPENSE_DELETE_API, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('删除成功');
              this.$refs.siruiTable.clearCheckboxReserve();
              this.queryBtnClickHandler();
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      editBill() {
        // TODO 判断必须要选择行才可以跳转
        this.selectedList = this.$refs.siruiTable.getCheckboxRecords();
        if (!this.selectedList.length) {
          this.$message.warning('请选择行操作!');
          return;
        }
        let processStatusList = this.selectedList.filter((item) => item.processStatus == 1);
        if (processStatusList.length > 0) {
          this.$message.warning('已处理的费用清单不能进行调整!');
          return;
        }
        let contractNoStatus = null;
        let contractNoList = [];
        this.selectedList.map((item) => {
          contractNoList.push(item.contractNo);
        });

        contractNoStatus = this.isAllEqual(contractNoList);
        if (!contractNoStatus) {
          this.$message.warning('所选合同不一致');
          return;
        }
        this.showAdjustmentFeeDialog = true;
      },
      // 批量生成
      async batchCreate() {
        const selectedList = this.$refs.siruiTable.getCheckboxRecords();
        if (!selectedList.length) {
          this.$message.warning('请选择行操作');
          return;
        }
        let processStatusList = selectedList.filter((item) => item.processStatus == 1);

        if (processStatusList.length > 0) {
          this.$message.warning('已处理的费用清单不能再次创建');
          return;
        }
        let expenseIds = selectedList.map((item) => item.id);

        const { data } = await this.$axios.post(
          parkPropertyApi.RECEIVABLESEXPENSE_PREGENERATE_SETTLEMENT,
          {
            businessGroup: '园区',
            expenseIds: expenseIds,
          }
        );
        if (data.code == 0) {
          this.preSettlementTableData = data.data;
          this.showBatchCreateSettlementDialog = true;
        } else {
          if (data.msg != null) {
            return this.$message.error(data.msg);
          }
          return this.$message.error('操作失败');
        }
      },

      add() {
        this.addExpensesDialogForm = {
          businessCategory: '04',
          businessCompanyNo: this.userInfo.companyCode,
          businessDepartmentCode: this.userInfo.departmentCode,
          contractNo: this.contractNo,
        };
        this.showAddExpensesDialog = true;
      },
      // 创建
      create() {
        const selectedList = this.$refs.siruiTable.getCheckboxRecords();
        if (!selectedList.length) {
          this.$message.warning('请选择行操作');
          return;
        }
        let processStatusList = selectedList.filter((item) => item.processStatus == 1);
        console.log(processStatusList, 'processStatusList');
        if (processStatusList.length > 0) {
          this.$message.warning('已处理的费用清单不能再次创建');
          return;
        }
        // let productNameList = [];
        // let productNameStatus = null;
        let contractNoList = [];
        let contractNoStatus = null;
        let ids = [];
        selectedList.map((item) => {
          // productNameList.push(item.productName);
          contractNoList.push(item.contractNo);
          ids.push(+item.id);
        });
        // productNameStatus = this.isAllEqual(productNameList);
        contractNoStatus = this.isAllEqual(contractNoList);

        if (!contractNoStatus) {
          this.$message.warning('所选合同不一致');
          return;
        }

        let path = {
          path: '/receivablesAndPayables/parkPropertyReceivablesCreate',
          name: 'parkPropertyReceivablesCreate',
          meta: {
            keepAlive: true,
            title: '应收结算单列表',
          },
          query: {
            status: 'create',
            id: ids,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 导出
      async export() {
        const selectedList = this.$refs.siruiTable.getCheckboxRecords();
        if (selectedList.length > 0) {
          const postData = [];
          selectedList.map((item) => {
            postData.push(item.id);
          });
          const { data } = await this.$axios.post(RECEIVABLES_PROPERTY.RECEIVABLESEXPENSE_EXPORT, {
            ids: postData,
            businessCategory: this.query?.businessCategory,
          });
          if (data.code === 0) {
            window.location.href = data.data;
            this.$message.success('导出成功');
          } else {
            this.$message.error(`${data.msg}`);
          }
        } else {
          const postData = this.query;
          const { data } = await this.$axios.post(
            RECEIVABLES_PROPERTY.RECEIVABLESEXPENSE_EXPORT,
            postData
          );
          if (data.code === 0) {
            window.location.href = data.data;
            this.$message.success('导出成功');
          } else {
            this.$message.error(`${data.msg}`);
          }
        }
      },
      // 生成费用
      generate() {
        this.generateExpensesDialogform = {
          businessCompanyNo: this.userInfo.companyCode,
        };
        this.showGenerateExpensesDialog = true;
        console.log('点击了生成费用');
      },
      // 为生成费用的合同
      contract() {
        this.showContractDialog = true;
        console.log('点击了生成费用');
      },
      saveGenerate() {
        this.showGenerateExpensesDialog = false;
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      saveCost() {
        this.showContractDialog = false;
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      savePreGenerate() {
        this.showBatchCreateSettlementDialog = false;
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      //判断数组里元素是否全相等
      isAllEqual(array) {
        if (array.length > 0) {
          return !array.some(function (value) {
            return value !== array[0];
          });
        } else {
          return true;
        }
      },

      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        this.multipleSelection = row;
        this._computedAmount(row);
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索', this.query);
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this._computedAmount([]);
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this._getDepartmentByCompanyCodeApi(this.userInfo.companyCode);
        this.query = {
          businessCompanyNo: this.userInfo.companyCode,
          businessDepartmentCode: this.userInfo?.departmentCode,
          businessCategory: '04',
        };
        this._computedAmount([]);
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
    },
    watch: {
      contractNo: {
        handler(val) {
          this.query = {
            ...this.query,
            contractNo: val,
          };
          this.$forceUpdate();
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
